import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import StatisticsStep from "../../molecules/statisticsStep/StatisticsStep";
import AnalysesListStep from "../../molecules/analysesListStep/AnalysesListStep";
import "../newAnalysisSidebar/NewAnalysisSidebar.css";
import "./UserHistoricSidebar.css";
import { SECTIONS } from "../../../conts/navigationConstants";
import { EMPTY_FILTERS } from "../../../conts/historyConsts";

const UserHistoricSidebar = ({
  onClose,
  stats,
  onRetry,
  statsIds,
  onFetchStatsByIds,
  analyses,
  onFetchAnalyses,
  reportPreview,
  onOpenReportPreview,
  onCloseReportPreview,
  onOpenAnalysis,
  openingId,
  onDelete,
  viewedId,
  onCloseViewed,
  statsCandidates,
  onFetchStatsCandidates,
}) => {
  const [section, setSection] = useState(0);
  // stats picker filters: lives here so it survives tab switches
  const [statsDraft, setStatsDraft] = useState(EMPTY_FILTERS);
  // in the report preview, ✕ goes back to the list; otherwise it closes the panel
  const inPreview = section === 1 && Boolean(reportPreview?.item);
  const handleClose = inPreview ? onCloseReportPreview : onClose;
  const closeLabel = inPreview
    ? "Fermer le rapport et revenir à la liste"
    : "Fermer l'historique des analyses";
  return (
    <aside className="analysis-sidebar">
      <div className="analysis-sidebar__header">
        <nav
          className="analysis-sidebar__stepper analysis-sidebar__stepper--two"
          aria-label="Historique des analystes"
        >
          {SECTIONS.map((label, i) => (
            <button
              key={label}
              type="button"
              className={`analysis-sidebar__step ${i === section ? "is-active" : ""}`}
              aria-current={section === i ? "step" : undefined}
              onClick={() => setSection(i)}
            >
              <span className="analysis-sidebar__num">{i + 1}</span>
              {label}
            </button>
          ))}
        </nav>
        <IconButton
          onClick={handleClose}
          size="small"
          aria-label={closeLabel}
          title={closeLabel}
          sx={{ color: "var(--color-burgundy)", flexShrink: 0 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {section === 0 && (
        <StatisticsStep
          data={stats.data}
          isLoading={stats.isLoading}
          error={stats.error}
          onRetry={onRetry}
          statsIds={statsIds}
          onApplyIds={onFetchStatsByIds}
          onResetIds={onRetry}
          candidates={statsCandidates}
          onFetchCandidates={onFetchStatsCandidates}
          draft={statsDraft}
          onDraftChange={setStatsDraft}
        />
      )}
      {section === 1 && (
        <AnalysesListStep
          analyses={analyses}
          onFetch={onFetchAnalyses}
          onPreview={onOpenReportPreview}
          preview={reportPreview}
          onClosePreview={onCloseReportPreview}
          onOpen={onOpenAnalysis}
          openingId={openingId}
          onDelete={onDelete}
          viewedId={viewedId}
          onCloseViewed={onCloseViewed}
        />
      )}
    </aside>
  );
};

export default UserHistoricSidebar;
